// extracted by mini-css-extract-plugin
module.exports = {"Container":"AltArtImgDisplay_Container__3PDHV","SpinnerContainer":"AltArtImgDisplay_SpinnerContainer__16mG9","CardImage":"AltArtImgDisplay_CardImage__11lnB"};